module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-2019-mobile-411x61.dbc1b35c.jpg";